// extracted by mini-css-extract-plugin
export default {"marketer-info-container":"MarketerInfo_marketer-info-container__6gqc0","marketer-icon":"MarketerInfo_marketer-icon__NoMpa","marketer-role":"MarketerInfo_marketer-role__1gnyR"};